import * as ko from "knockout";
import {IMessageData, IOrganization, TBaseOrObservableOrFunctionType} from "../../index";
import {global} from "../../appContext";
import {nsTooltip} from "../../util/nsTooltip";
import {_d, getAnyValue} from "../../util/misc";
import organizationHtml from './organization.html?raw';

export const template = organizationHtml;

interface IParams {
    orgnr?: TBaseOrObservableOrFunctionType<IOrganization['organizationid']>
    org?: TBaseOrObservableOrFunctionType<IOrganization>
    linkable?: boolean
}

export class viewModel {
    private readonly isReady: KnockoutObservable<boolean | null> = ko.observable(null)
    private readonly messageData: KnockoutObservable<IMessageData | null> = ko.observable(null)
    private linkable: boolean

    constructor(private params: IParams) {
        this.linkable = params.linkable ?? false
    }

    private onClick() {
        const org = this._getOrg();
        if (org) {
            global.login.setSelectedOrganizationById(org.organizationid)
        }
    }

    private getTitle() {
        const org = this._getOrg()
        if (!org) {
            return 'N/A'
        }
        return nsTooltip.getTitle_organization(org)
    }

    private getOrg() {
        const org = this._getOrg()
        if (!org) {
            return {
                organizationid: this.params.orgnr ?? 'N/A',
                organizationame: getAnyValue(this.params.org)?.organizationame ?? 'N/A',
            }
        }
        return org
    }

    private _getOrg() {
        if (this.params.org) {
            return getAnyValue(this.params.org)
        }
        if (this.params.orgnr) {
            return global.login.getOrganizationById(getAnyValue(this.params.orgnr))
        }
    }

}
